(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comhenrycao-consignment"]) return;
  try {
    
  console.log('COMHENRYCAO V2 - JS READY');
  var iframe = document.getElementById('comhenrycao-stripe-jotform-iframe');
  window.addEventListener(
    'message',
    function (e) {
      var origins = ['https://cnsm.camilla.com'];
      console.log('Message received: ', e.data);

      if (origins.includes(e.origin)) {
        if (e.data && e.data.type === 'setHeight') {
          console.log('setHeight: ', e.data.height);
          iframe.style.height = e.data.height + 'px';
          window.lastSetHeightMessageReceived = true;
        }
        
        if (e.data && e.data.type === 'isLoading') {
          const iframeContainer = document.getElementById('comhenrycao-stripe-jotform-container');
          let spinner = document.querySelector('.loading-container');
        
          if (e.data.isLoading === 'True') {
            if (!spinner) {
              spinner = document.createElement('div');
              spinner.className = 'loading-container';
              spinner.innerHTML = `
                <div class="spinner"></div>
              `;
              iframeContainer.appendChild(spinner);
            }
            spinner.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } else if (e.data.isLoading === 'False') {
            if (spinner) {
              spinner.remove();
            }
          }
        }

        if (e.data && e.data.type === 'isRedirect') {
          console.log('isRedirect: ', e.data.isRedirect);
          if (e.data.isRedirect === 'True') {
            window.location.href = 'https://camilla.com/pages/us-consignment';
            window.location.replace('https://camilla.com/pages/us-consignment');
          }
        }

        if (e.data && e.data.type === 'formError') {
          let overlay = document.getElementById('parentErrorOverlay');
          if (!overlay) {
            overlay = document.createElement('div');
            overlay.id = 'parentErrorOverlay';
            overlay.style.position = 'fixed';
            overlay.style.top = '0';
            overlay.style.left = '0';
            overlay.style.width = '100%';
            overlay.style.height = '100%';
            overlay.style.background = 'rgba(0,0,0,0.5)';
            overlay.style.zIndex = '9998';
            overlay.style.display = 'none';
            document.body.appendChild(overlay);
          }

          let popup = document.getElementById('parentErrorPopup');
          if (!popup) {
            popup = document.createElement('div');
            popup.id = 'parentErrorPopup';
            popup.style.position = 'fixed';
            popup.style.top = '50%';
            popup.style.left = '50%';
            popup.style.transform = 'translate(-50%, -50%)';
            popup.style.background = '#fff';
            popup.style.border = '1px solid #ccc';
            popup.style.padding = '20px';
            popup.style.zIndex = '9999';
            popup.style.textAlign = 'center';
            popup.innerHTML = `
                  <div id="parentErrorMessage" style="margin-bottom:20px;"></div>
                  <button id="closeParentError" style="
                    background: black; 
                    color: white; 
                    border: none; 
                    padding: 10px 20px; 
                    cursor: pointer; 
                    margin: 0 auto;">
                    Close
                  </button>
                `;
            document.body.appendChild(popup);

            const closeBtn = document.getElementById('closeParentError');
            closeBtn.addEventListener('click', () => {
              popup.style.display = 'none';
              overlay.style.display = 'none';
              const iframeContainer = document.getElementById('comhenrycao-stripe-jotform-container');
              let spinner = document.querySelector('.loading-container');
              if (spinner) {
                spinner.remove();
              }
            });
          }

          const parentErrorMessage = document.getElementById('parentErrorMessage');
          parentErrorMessage.innerText = e.data.message;

          overlay.style.display = 'block';
          popup.style.display = 'block';
        }
      }
    },
    false
  );

  } catch(e) { console.error(e); }
})();
})();
